export const virtualCardDisplayTypes = [
  "action",
  "heading",
  "link",
  "placeholder",
  "text",
  "iframe",
] as const;

export type VirtualCardDisplay = (typeof virtualCardDisplayTypes)[number];

export const isVirtualCardDisplayType = (
  value: string,
): value is VirtualCardDisplay =>
  typeof value === "string" &&
  // Unjustified type cast. FIXME
  virtualCardDisplayTypes.includes(value as VirtualCardDisplay);

export const cardDisplayTypes = [
  "table",
  "bar",
  "line",
  "pie",
  "scalar",
  "row",
  "area",
  "combo",
  "pivot",
  "smartscalar",
  "gauge",
  "progress",
  "funnel",
  "object",
  "map",
  "scatter",
  "boxplot",
  "waterfall",
  "sankey",
  "treemap",
  "list",
] as const;

export const isCardDisplayType = (value: unknown): value is CardDisplayType =>
  typeof value === "string" &&
  // Unjustified type cast. FIXME
  cardDisplayTypes.includes(value as CardDisplayType);

export type CardDisplayType = (typeof cardDisplayTypes)[number];

export type CustomVizDisplayType = `custom:${string}`;

export type QueryVisualizationDisplayType =
  | CardDisplayType
  | CustomVizDisplayType;

export type VisualizationDisplay =
  | VirtualCardDisplay
  | QueryVisualizationDisplayType
  // internal-only display registered by the audit app, not saveable on cards
  | "audit-table";

export type TimeseriesDisplayType = Extract<
  CardDisplayType,
  "line" | "area" | "bar"
>;
